import React from 'react'
import {Link} from 'react-router-dom'
import erimg from '../../images/404/404.png'


const Error = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(
        <section className="error-404-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="content clearfix">
                            <div className="error" style={{position: 'relative', textAlign: 'center', display: 'inline-block'}}>
                                <img src={erimg} alt="" style={{
                                    display: 'block', 
                                    maxWidth: '450px', 
                                    width: '100%', 
                                    height: 'auto', 
                                    margin: '0 auto',
                                    borderRadius: '30px',
                                    boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                                }}/>
                                <div style={{
                                    position: 'absolute',
                                    top: '70%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }}>
                                    <Link 
                                        onClick={ClickHandler} 
                                        to="/home" 
                                        style={{
                                            padding: '12px 30px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            borderRadius: '30px',
                                            display: 'inline-block',
                                            background: '#0066cc !important',
                                            color: '#fff !important',
                                            textDecoration: 'none',
                                            cursor: 'pointer',
                                            transform: 'none !important',
                                            transition: 'none !important'
                                    }}>Back to Home</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Error;